<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              {{ $t("action.add") }} /{{ $t("action.update") }}
              {{ $t("sentence.deliveryEstimate") }}
            </div>
          </div>
          <div class="card-body card-white">
            <div v-for="(input, k) in inputs" :key="k">
              <div class="form-group">
                <label>Distance minimale </label>
                <input
                  type="text"
                  class="form-control col-8"
                  v-model="input.start_distance"
                />
              </div>
              <div class="form-group">
                <label>Distance maximale</label>
                <input
                  type="text"
                  class="form-control col-8"
                  v-model="input.end_distance"
                />
              </div>
              <div class="form-group">
                <label>Prix</label>
                <input
                  type="text"
                  class="form-control col-8"
                  v-model="input.price"
                />
              </div>

              <span>
                <i
                  class="fas fa-minus-circle"
                  @click="remove(k)"
                  v-show="k || (!k && inputs.length > 1)"
                  >Remove</i
                >
                <i
                  class="fas fa-plus-circle"
                  @click="add(k)"
                  v-show="k == inputs.length - 1"
                  >Add fields</i
                >
              </span>
            </div>
          </div>
          <div class="card-footer">
            <button class="btn btn-default pull-right" @click="addCandidate">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputs: [
        {
          start_distance: "",
          end_distance: "",
          price: "",
        },
      ],
    };
  },

  methods: {
    add() {
      this.inputs.push({
        name: "",
        party: "",
      });
      console.log(this.inputs);
    },

    remove(index) {
      this.inputs.splice(index, 1);
    },

    addCandidate() {
      this.axios
        .post("/candidates", {
          my_prop_name: JSON.stringify(this.inputs),
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
